var _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTreatmentMedication(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.014,
    height: 12,
    viewBox: "0 0 12.014 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656",
    transform: "translate(3.494)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2714",
    "data-name": "Path 2714",
    d: "M118.834.936a2.406,2.406,0,0,0-3.4,0l-2.356,2.356L116.481,6.7l2.353-2.359A2.408,2.408,0,0,0,118.834.936Zm-2.415,1.392-1.072,1.057,0,0a.31.31,0,1,1-.432-.444l1.075-1.057,0,0a.309.309,0,1,1,.429.444Z",
    transform: "translate(-113.075 -0.23)",
    fill: "#0078e2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_658",
    "data-name": "Group 658",
    transform: "translate(0 3.48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2715",
    "data-name": "Path 2715",
    d: "M3.073,112.818.7,115.192a2.413,2.413,0,0,0,3.422,3.4l2.359-2.368Z",
    transform: "translate(0 -112.818)",
    fill: "#0078e2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_660",
    "data-name": "Group 660",
    transform: "translate(8.164 8.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2716",
    "data-name": "Path 2716",
    d: "M267.028,263.418l-3.353,3.357a2.393,2.393,0,0,0,3.353-3.357Z",
    transform: "translate(-263.675 -263.418)",
    fill: "#0078e2"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662",
    transform: "translate(7.229 7.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2717",
    "data-name": "Path 2717",
    d: "M235.968,233.418a2.394,2.394,0,0,0-1.9,3.851l3.353-3.353A2.367,2.367,0,0,0,235.968,233.418Z",
    transform: "translate(-233.575 -233.418)",
    fill: "#0078e2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatmentMedication);
export default __webpack_public_path__ + "static/media/treatment_medication.d511e509570117f19161e6d255cbb18e.svg";
export { ForwardRef as ReactComponent };